import React, { useState, useEffect, useContext } from "react";
import { IoIosArrowForward } from "react-icons/io";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Bread from "../../common/Bread";
import Loader from "../../common/Loader";
import { LangContext } from "../../context/LangContext";
import "./services.scss";

const Services = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [isActive, setIsActive] = useState(slug);

  const lang = useContext(LangContext);
  const nep = lang.state.np;

  useEffect(() => {
    setIsActive(slug);
  }, [slug]);

  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ["servicesData"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/service/all`)
        .then((res) => res.data),
  });

  if (isFetching) return <Loader />;
  if (isLoading) return <Loader />;
  if (error) return "An error has occurred: " + error.message;

  // Breadcrumb
  const breadcrumList = {
    image: "",
    title: nep ? "सेवाहरू" : "Services",
    l1: nep ? "होम" : "Home",
    l2: nep ? "सेवा" : "Service",
    l3: "",
  };

  return (
    <Bread data={breadcrumList}>
      <div className="servicePageContainer">
        <div className="contentContainer">
          {data.items.map((i) => (
            <div
              key={i.slug}
              className="content"
              style={{ display: isActive === i.slug ? "block" : "none" }}
            >
              <h2 className="content-title">
                # {nep ? i.Title_nepali || i.Title : i.Title}
              </h2>
              <div
                className="services-ck-content"
                dangerouslySetInnerHTML={{
                  __html: nep
                    ? i.Description_nepali || i.Description
                    : i.Description,
                }}
              ></div>
            </div>
          ))}
        </div>

        <div className="buttons">
          <h2>{nep ? "सेवाहरू" : "Services"}</h2>
          {data.items.map((i) => (
            <div
              key={i.slug}
              onClick={() => {
                navigate(`/services/${i.slug}`);
                window.scrollTo(0, 0);
              }}
              className="btn"
              style={{
                color: isActive === i.slug ? "#fff" : "#0f2137",
                backgroundColor: isActive === i.slug ? "#003399" : "#fff",
              }}
            >
              <p>{nep ? i.Title_nepali || i.Title : i.Title}</p>
              <IoIosArrowForward className="icon" />
            </div>
          ))}
        </div>
      </div>
    </Bread>
  );
};

export default Services;
